/**
 * @internal
 */
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
const useDirectionStyle = (value) => {
    const { isRTL } = useDirection();
    return isRTL ? value * -1 : value;
};
export default useDirectionStyle;
